export const APP_VERSION = "99.0.0"; // Developement version